import { useTranslation } from 'react-i18next';
import { DecorativeIconButton, Tooltip } from '../Ant';
import { Star, StarFilled } from '../icons';

interface FavouriteStatusProps {
  isFavourite?: boolean;
  testId?: string;
  tooltip?: string;
}

/**
 * A card's favourite star. The card is the control, so the star is no tab stop and stays hidden
 * from assistive technology; a favourite is announced as part of the card through hidden text.
 */
const FavouriteStatus = ({ isFavourite, testId, tooltip }: FavouriteStatusProps) => {
  const { t } = useTranslation();

  const star = (
    <DecorativeIconButton
      data-testid={testId}
      className={`favourite-icon ${isFavourite ? 'active' : ''}`}
    >
      {isFavourite ? <StarFilled /> : <Star />}
    </DecorativeIconButton>
  );

  return (
    <>
      {tooltip ? (
        <Tooltip title={tooltip} placement="top" arrow={false}>
          {star}
        </Tooltip>
      ) : (
        star
      )}
      {isFavourite && <span className="visually-hidden">{t('common:favorite')}</span>}
    </>
  );
};

export default FavouriteStatus;
